/* Herbonise — home sections behaviour: product carousel, review slider, FAQ, quickshop, wishlist hearts */
(function () {
  'use strict';
  if (window.__hbSectionsLoaded) return;
  window.__hbSectionsLoaded = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Product carousel ---------- */
  function initCarousel(el) {
    if (el.dataset.hbReady) return;
    el.dataset.hbReady = '1';
    var track = el.querySelector('[data-hb-track]');
    var prev = el.querySelector('[data-hb-prev]');
    var next = el.querySelector('[data-hb-next]');
    if (!track) return;
    function step() {
      var slide = track.querySelector('li');
      if (!slide) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      el.classList.toggle('is-static', max <= 0);
    }
    prev && prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next && next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  /* ---------- Fade slider (testimonials) ---------- */
  function initFade(el) {
    if (el.dataset.hbReady) return;
    el.dataset.hbReady = '1';
    var slides = $$('[data-hb-slide]', el);
    if (slides.length < 2) return;
    var index = 0, timer = null;
    var autoplay = el.dataset.autoplay === 'true';
    var speed = parseInt(el.dataset.speed, 10) || 7000;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function go(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        s.classList.toggle('is-active', n === index);
        s.setAttribute('aria-hidden', n === index ? 'false' : 'true');
      });
    }
    function play() { stop(); if (autoplay && !reduce) timer = setInterval(function () { go(index + 1); }, speed); }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    var p = el.querySelector('[data-hb-prev]'), n = el.querySelector('[data-hb-next]');
    p && p.addEventListener('click', function () { go(index - 1); play(); });
    n && n.addEventListener('click', function () { go(index + 1); play(); });
    el.addEventListener('mouseenter', stop);
    el.addEventListener('mouseleave', play);
    var x0 = null;
    el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
      x0 = null; play();
    }, { passive: true });
    el.addEventListener('shopify:block:select', function (e) {
      var s = e.target.closest('[data-hb-slide]');
      if (s) { stop(); go(parseInt(s.dataset.index, 10)); }
    });
    el.addEventListener('shopify:block:deselect', play);
    play();
  }

  /* ---------- FAQ: one open at a time ---------- */
  function initAccordion(el) {
    if (el.dataset.hbReady) return;
    el.dataset.hbReady = '1';
    var items = $$('details', el);
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        items.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }

  /* ---------- Wishlist hearts ---------- */
  var WISHLIST_KEY = 'herbonise:wishlist';
  function readList() {
    try { var v = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function toggleWish(handle) {
    if (window.Herbonise && window.Herbonise.wishlist) return window.Herbonise.wishlist.toggle(handle);
    var list = readList(), i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else list.push(handle);
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) {}
    $$('[data-hb-wishlist-count]').forEach(function (c) { c.textContent = list.length; });
    return i === -1;
  }
  function paintHearts(ctx) {
    var list = readList();
    $$('[data-hb-wish]', ctx).forEach(function (b) {
      var on = list.indexOf(b.dataset.hbWish) > -1;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  /* ---------- Quick add ---------- */
  function addToCart(btn) {
    var id = parseInt(btn.dataset.hbQuickAdd, 10);
    if (!id || btn.disabled) return;
    var label = btn.querySelector('[data-hb-quick-label]') || btn;
    var original = label.textContent;
    btn.disabled = true;
    btn.classList.add('is-loading');
    if (window.Herbonise && typeof window.Herbonise.addToCart === 'function') {
      window.Herbonise.addToCart([{ id: id, quantity: 1 }])
        .then(function (res) {
          label.textContent = res.drawerOpened ? original : 'Added ✓';
          var card = btn.closest('[data-hb-card]');
          var panel = card && card.querySelector('[data-hb-variants]');
          if (panel) { panel.hidden = true; var t = card.querySelector('[data-hb-quick-toggle]'); t && t.setAttribute('aria-expanded', 'false'); }
        })
        .catch(function (err) { label.textContent = (err && err.message) || 'Unavailable'; })
        .then(function () {
          btn.classList.remove('is-loading');
          setTimeout(function () { label.textContent = original; btn.disabled = false; }, 1600);
        });
      return;
    }
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        btn.classList.remove('is-loading');
        label.textContent = res.ok ? 'Added ✓' : (res.json && res.json.description) || 'Unavailable';
        if (res.ok) {
          fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
            // v2: badge shows the number only (was: '(' + c.item_count + ')')
            $$('[data-hb-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
          }).catch(function () {});
          document.dispatchEvent(new CustomEvent('herbonise:cart-added', { detail: { variantId: id } }));
        }
        setTimeout(function () {
          label.textContent = original;
          btn.disabled = false;
          var card = btn.closest('[data-hb-card]');
          var panel = card && card.querySelector('[data-hb-variants]');
          if (panel && res.ok) { panel.hidden = true; var t = card.querySelector('[data-hb-quick-toggle]'); t && t.setAttribute('aria-expanded', 'false'); }
        }, 1600);
      })
      .catch(function () { btn.classList.remove('is-loading'); btn.disabled = false; label.textContent = original; });
  }

  document.addEventListener('click', function (e) {
    var wish = e.target.closest('[data-hb-wish]');
    if (wish) {
      e.preventDefault();
      var on = toggleWish(wish.dataset.hbWish);
      $$('[data-hb-wish="' + wish.dataset.hbWish + '"]').forEach(function (b) {
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      return;
    }
    var toggle = e.target.closest('[data-hb-quick-toggle]');
    if (toggle) {
      var card = toggle.closest('[data-hb-card]');
      var panel = card && card.querySelector('[data-hb-variants]');
      if (panel) {
        panel.hidden = !panel.hidden;
        toggle.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
      }
      return;
    }
    var add = e.target.closest('[data-hb-quick-add]');
    if (add) { e.preventDefault(); addToCart(add); return; }
    // click outside closes open quickshop panels
    $$('[data-hb-variants]:not([hidden])').forEach(function (p) {
      if (!p.closest('[data-hb-card]').contains(e.target)) {
        p.hidden = true;
        var t = p.closest('[data-hb-card]').querySelector('[data-hb-quick-toggle]');
        t && t.setAttribute('aria-expanded', 'false');
      }
    });
  });
  document.addEventListener('herbonise:wishlist', function () { paintHearts(document); });
  window.addEventListener('storage', function (e) { if (e.key === WISHLIST_KEY) paintHearts(document); });

  /* ---------- Scroll helper ----------
     Scrolls the element's real scroll container (window in Dawn, .page-wrapper in Horizon)
     instead of Element.scrollIntoView, which can also shift an overflow:hidden <html>. */
  function scrollIntoViewSafe(el) {
    var r = el.getBoundingClientRect();
    var header = document.querySelector('.hb-header');
    var offset = (header ? header.offsetHeight : 0) + 16;
    if (r.top >= offset && r.top < window.innerHeight * 0.6) return;
    var sc = el.parentElement;
    while (sc && sc !== document.body && sc !== document.documentElement) {
      var oy = getComputedStyle(sc).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && sc.scrollHeight > sc.clientHeight) break;
      sc = sc.parentElement;
    }
    var delta = r.top - offset;
    if (sc && sc !== document.body && sc !== document.documentElement) sc.scrollBy({ top: delta, behavior: 'smooth' });
    else window.scrollBy({ top: delta, behavior: 'smooth' });
  }

  /* ---------- Hair quiz (Find Your Hair Solution) ---------- */
  function initQuiz(rootEl) {
    if (rootEl.dataset.hbReady) return;
    rootEl.dataset.hbReady = '1';
    var panel = rootEl.querySelector('[data-hb-quiz]');
    var openBtn = rootEl.querySelector('[data-hb-quiz-open]');
    // v3: the quiz page has no open button; it starts straight away (data-hb-quiz-autostart)
    // if (!panel || !openBtn) return;
    var autostart = rootEl.hasAttribute('data-hb-quiz-autostart');
    if (!panel || (!openBtn && !autostart)) return;
    var steps = {};
    $$('[data-hb-q]', panel).forEach(function (el) { steps[el.dataset.hbQ] = el; });
    var bar = panel.querySelector('[data-hb-quiz-bar]');
    var stepLabel = panel.querySelector('[data-hb-quiz-step]');
    var tips = {};
    try { tips = JSON.parse(panel.querySelector('[data-hb-quiz-tips]').textContent); } catch (e) {}
    var state = { audience: null, concern: null, scalp: null };
    var history = [];
    var skipFocus = false;

    function concernsFor(aud) {
      return $$('[data-hb-q="concern"] [data-hb-answer]', panel).filter(function (b) {
        var a = b.dataset.audience;
        return a === aud || (a === 'all' && (aud === 'adult' || aud === 'kids'));
      });
    }
    function plan() {
      // Which steps this person will see, given the answers so far
      var p = ['audience'];
      if (!state.audience || concernsFor(state.audience).length > 1) p.push('concern');
      // v3: question 3 can be switched off in the quiz page settings
      // if (state.audience !== 'beard') p.push('scalp');
      if (state.audience !== 'beard' && steps.scalp) p.push('scalp');
      return p;
    }
    function show(name) {
      Object.keys(steps).forEach(function (k) { steps[k].hidden = k !== name; });
      var p = plan();
      var idx = name === 'result' ? p.length : p.indexOf(name);
      bar.style.width = (name === 'result' ? 100 : Math.round((idx / p.length) * 100) + 8) + '%';
      stepLabel.textContent = name === 'result' ? '' : 'Question ' + (idx + 1) + ' of ' + p.length;
      var focusTarget = steps[name].querySelector('button, a');
      // v3: skipFocus is set while the quiz page auto-starts on load
      if (focusTarget && !skipFocus) setTimeout(function () { focusTarget.focus({ preventScroll: true }); }, 30);
    }
    function go(name) { history.push(name); show(name); }

    function renderResult() {
      var tpl = panel.querySelector('[data-hb-result-for="' + state.concern + '"]');
      if (!tpl) return;
      steps.result.querySelector('[data-hb-result-title]').textContent = tpl.dataset.title;
      var list = steps.result.querySelector('[data-hb-result-products]');
      list.innerHTML = '';
      list.appendChild(tpl.content.cloneNode(true));
      var link = steps.result.querySelector('[data-hb-result-link]');
      link.href = tpl.dataset.url;
      var tip = steps.result.querySelector('[data-hb-result-tip]');
      var tipText = state.scalp && tips[state.scalp];
      tip.hidden = !tipText;
      tip.textContent = tipText || '';
      // "Pair it with" — routine product not already recommended
      var pairWrap = steps.result.querySelector('[data-hb-result-pair]');
      var pairTpl = panel.querySelector('[data-hb-result-pair-tpl]');
      pairWrap.hidden = true;
      if (pairTpl && state.audience !== 'beard' && pairTpl.dataset.handle !== tpl.dataset.handle) {
        var shown = $$('[data-hb-wish]', list).map(function (b) { return b.dataset.hbWish; });
        var frag = pairTpl.content.cloneNode(true);
        var pick = Array.prototype.slice.call(frag.querySelectorAll('li')).filter(function (li) { return shown.indexOf(li.dataset.handle) === -1; })[0];
        if (pick) {
          var pairList = pairWrap.querySelector('[data-hb-result-pair-list]');
          pairList.innerHTML = '';
          pairList.appendChild(pick);
          pairWrap.hidden = false;
        }
      }
      paintHearts(steps.result);
      go('result');
      scrollIntoViewSafe(panel);
    }

    function next(from) {
      var p = plan();
      var i = p.indexOf(from);
      var upcoming = p[i + 1];
      if (from === 'audience' && concernsFor(state.audience).length === 1) state.concern = concernsFor(state.audience)[0].dataset.hbAnswer;
      if (upcoming === 'concern') {
        $$('[data-hb-answer]', steps.concern).forEach(function (b) { b.hidden = concernsFor(state.audience).indexOf(b) === -1; });
      }
      if (upcoming) go(upcoming); else renderResult();
    }

    /* v3: open/close now work without an open button (quiz page). Previous version:
    function open() {
      panel.hidden = false;
      openBtn.setAttribute('aria-expanded', 'true');
      state = { audience: null, concern: null, scalp: null };
      history = [];
      go('audience');
      scrollIntoViewSafe(panel);
    }
    function close() {
      panel.hidden = true;
      openBtn.setAttribute('aria-expanded', 'false');
      openBtn.focus();
    }

    openBtn.addEventListener('click', function () { panel.hidden ? open() : close(); });
    panel.querySelector('[data-hb-quiz-close]').addEventListener('click', close);
    */
    function open(noScroll) {
      panel.hidden = false;
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      state = { audience: null, concern: null, scalp: null };
      history = [];
      $$('.is-selected', panel).forEach(function (b) { b.classList.remove('is-selected'); });
      go('audience');
      if (noScroll !== true) scrollIntoViewSafe(panel);
    }
    function close() {
      if (autostart) return; // the quiz page keeps the quiz open
      panel.hidden = true;
      if (openBtn) { openBtn.setAttribute('aria-expanded', 'false'); openBtn.focus(); }
    }

    if (openBtn) openBtn.addEventListener('click', function () { panel.hidden ? open() : close(); });
    var closeBtn = panel.querySelector('[data-hb-quiz-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);
    $$('[data-hb-quiz-restart]', panel).forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-hb-quiz-back]', panel).forEach(function (b) {
      b.addEventListener('click', function () {
        history.pop();
        var prev = history[history.length - 1] || 'audience';
        show(prev);
      });
    });
    panel.addEventListener('click', function (e) {
      var ans = e.target.closest('[data-hb-answer]');
      if (!ans) return;
      var step = ans.closest('[data-hb-q]').dataset.hbQ;
      $$('[data-hb-answer]', steps[step]).forEach(function (b) { b.classList.toggle('is-selected', b === ans); });
      state[step] = ans.dataset.hbAnswer;
      if (step === 'audience') { state.concern = null; state.scalp = null; }
      setTimeout(function () { next(step); }, 160);
    });
    panel.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    rootEl.addEventListener('shopify:section:select', function () { if (panel.hidden) open(); });
    // v3: quiz page — show question 1 right away, without scrolling or moving focus
    if (autostart) {
      skipFocus = true;
      open(true);
      skipFocus = false;
    }
  }

  /* ---------- Library topic tabs ---------- */
  function initLibrary(el) {
    if (el.dataset.hbReady) return;
    el.dataset.hbReady = '1';
    var tabs = $$('[data-hb-topic]', el);
    var items = $$('.hb-lib__item', el);
    var empty = el.querySelector('[data-hb-lib-empty]');
    var max = parseInt(el.dataset.show, 10) || 4;
    function apply(topic) {
      var n = 0;
      items.forEach(function (it) {
        var match = !topic || it.dataset.tags.indexOf('|' + topic + '|') > -1;
        var show = match && n < max;
        it.hidden = !show;
        it.classList.toggle('is-featured', show && n === 0);
        if (show) n++;
      });
      if (empty) empty.hidden = n > 0;
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (o) { var on = o === t; o.classList.toggle('is-active', on); o.setAttribute('aria-selected', on ? 'true' : 'false'); });
        apply(t.dataset.hbTopic);
      });
    });
  }

  /* ---------- Boot ---------- */
  function init(ctx) {
    $$('[data-hb-carousel]', ctx).forEach(initCarousel);
    $$('[data-hb-fade-slider]', ctx).forEach(initFade);
    $$('[data-hb-accordion-single]', ctx).forEach(initAccordion);
    $$('[data-hb-quiz-root]', ctx).forEach(initQuiz);
    $$('[data-hb-library]', ctx).forEach(initLibrary);
    paintHearts(ctx);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
